angular.module 'zc.commonApi'

.filter 'currentStatus', ->
  (campaign) ->
    isRunning = (campaign) ->
      moment(campaign.start_at).diff(moment()) < 0 and moment(campaign.end_at).diff(moment()) > 0
    hasNotStartedYet = (campaign) ->
      moment(campaign.start_at).diff(moment()) > 0
    hasEnded = (campaign) ->
      moment(campaign.end_at).diff(moment()) < 0
    hasIncentives = (campaign) ->
      _.get(campaign, 'incentives', []).length > 0
    hasActiveIncentives = (campaign) ->
      return false unless hasIncentives(campaign)
      return typeof _.find(campaign.incentives, { current_status: 'active' }) != 'undefined'
    hasPendingIncentives = (campaign) ->
      return false unless hasIncentives(campaign)
      return typeof _.find(campaign.incentives, { current_status: 'pending' }) != 'undefined'

    # special handling for current status
    #
    # NOTE:
    # Similar logic is found in api_rails/app/models/client/campaign_concern.rb:45
    # But its result differs for each method. For this method, the current status value for
    # campaigns which ended before returns "terminated" but rails method returns "finished"
    current_status = campaign.status
    if current_status == 'activated'
      if isRunning(campaign)
        return 'active' if !campaign.requires_incentives || hasActiveIncentives(campaign)
        return 'pending' if hasPendingIncentives(campaign)
        return 'no_incentives'
      return 'pending' if hasNotStartedYet(campaign)
      # originally was finished on rails side
      return 'terminated' if hasEnded(campaign)
    if current_status == 'blocked'
      # if campaign has ended as blocked, show it as terminated (#1724)
      return 'terminated' if hasEnded(campaign)
    current_status



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/filters/current_status.coffee